/* Build style-sheets */
// Import pre-compiled bootstrap styles
import '../../node_modules/bootstrap/dist/css/bootstrap.css';
import '../../node_modules/bootstrap-slider/dist/css/bootstrap-slider.min.css';
import {datadogLogs} from '@datadog/browser-logs';

// Import mint's main scss file. This file imports style-partials that are not associated with a js module.
import '../scss/main.scss';

/* Import js libraries */
import $ from 'jquery';
import 'isomorphic-fetch';
// import 'bootstrap';
import pubsub from 'pubsub-js';
import Cookie from 'js-cookie';
window.themeVar = window.location.origin + '/wp-content/themes/mintmobile';
/* Import mint modules */
import videoModal from './video-modal';
import productPurchase from './product-purchase';
import slider from './slider';
import shoppingCart from './shopping-cart';
import calculator from './calculator';
import calc from './calc';
import gaTracker from './ga-tracker';
import customTracker from './custom-tracker';
import showOnClick from './show-on-click';
import shipToBilling from './ship-to-billing';
import surveyModal from './survey-modal';
import './intersection-observer';
import './taxToggle';
import dataTrackingPrivacyPolicy from './dataTrackingPrivacyPolicy';

// import './v3-js/v3-product'
if (process.env.BITBUCKET_DEPLOYMENT_ENVIRONMENT) {
  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    forwardErrorsToLogs: false,
    sessionSampleRate: 1,
    service: "ecomm-wp-sites",
    env: process.env.BITBUCKET_DEPLOYMENT_ENVIRONMENT
  });
};

datadogLogs.logger.info("The v2 theme file ran: /src/js/app.js", {type: 'file accessed', filename: "/src/js/app.js"});

const checkout = () =>
  import(/* webpackChunkName: "checkout" */ './checkout-page');
const cart = () => import(/* webpackChunkName: "cart" */ './cart-page');
const addMissingAltTag = () =>
  import(
    /* webpackChunkName: "addMissingAltTag" */ '../../v3/src/11_functions/_addMissingAltTag'
  );

/* Initialize Braze Web SDK */
// Initialization options are included, with suggested settings so they can be reviewed and discussed
// For production, remove commented out options
  /* appboy.initialize('c795deec-be42-422d-9a34-544bc240e899', {
  baseUrl: "sdk.iad-05.braze.com",
  //contentSecurityNonce: "GenerateRandomNonce", //Not sure if this is needed.
  //appVersion: "0.1", //Optional - Suggest incrementing when changes are made (1.0 when we go live)
  //devicePropertyAllowist: [], //Assumption is that all device properties are collected.
  //devicePropertyWhitelist: [], //Deprecated - Included just for completeness
  enableLogging: true, // default is false - true for testing, false for production.
  sessionTimeoutInSeconds: 30, //default is 30 minutes
  disablePushTokenMaintenance: false, //default is false
  inAppMessageZIndex: 1050, //1050 is default.
  openInAppMessagesInNewTab: true, //false is default
  allowUserSuppliedJavascript: false, //default is false
  //enableSdkAuthentication: false, //default is false. Will we be using this?
  //enableHtmlInAppMessages: false, //Deprecated - Included for completeness
  doNotLoadFontAwesome: false, //default is false
  allowCrawlerActivity: true, //default is false
  openCardsInNewTab: true, //false is default
  requireExplicitInAppMessageDismissal: false, //false is default.
  minimumIntervalBetweenTriggerActionsInSeconds: 30, //default is 30
  //localization: "", //do we want to use this for Ultra with the language selection?
  noCookies: false, //default is false (meaning cookies are allowed)
  //safariWebsitePushId: "pushID", //will we be using this? I'm guessing not out of the box.
  //manageServiceWorkerExternally: false, //default is fault - Probably should remain false.
  //serviceWorkerLocation: "someString", // This is only used if manageServiceWorkerExternally is true.


});

appboy.display.automaticallyShowNewInAppMessages(); //Will we be using this?
appboy.openSession();*/
/* End Braze Web SDK Initialization */

if (window.page === 'checkout') {
  checkout();
}

if (window.page === 'cart') {
  cart();
}
if (window.location.pathname === '/privacy-policy/') {
  dataTrackingPrivacyPolicy();
}

videoModal();
productPurchase();
slider();
addMissingAltTag();

if ($('.js-calculator').length) {
  calculator(); // original homepage plan calculator
} else {
  calc(); // new homepage savings calculator
}

customTracker();
gaTracker.init();
shipToBilling.init();

showOnClick.init(
  document.querySelector('.js-coupon-link'),
  document.querySelector('.js-coupon-form'),
);

// Initialize tooltips
$(document).ready(function() {
  const dataToggleEl = $('[data-toggle="tooltip"]');
  if (dataToggleEl.length) {
    dataToggleEl.tooltip();
  }
});

// Initialize the shopping cart functionality and then listen for shopping cart specific events.
shoppingCart.init();
pubsub.subscribe('cart.add_item', shoppingCart.addProduct);
pubsub.subscribe('cart.remove_item', shoppingCart.removeProduct);

if (document.getElementById('js-review-summaries')) {
  $('#js-review-summaries').owlCarousel({
    loop: true,
    margin: 10,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      715: {
        items: 3,
        loop: false,
      },
    },
  });
}

if ($('#js-video-carousel').length) {
  $('#js-video-carousel').owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    pullDrag: true,
    mouseDrag: true,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      720: {
        items: 2,
      },
      960: {
        items: 3,
      },
    },
  });
}


if (window.location.pathname.includes('/blog/')) {
  const searchForm = document.querySelector('#searchform');
  const searchInput = document.querySelector('#searchform #s');
  if (searchForm && searchInput) {
    searchForm.addEventListener('submit', () => {
      dataLayer.push({
        event: 'Blog Search',
        value: searchInput.value,
      });
    });
  }
}

/**
 * @name phoneCarousel
 * @description - Initialize the Phone Carousel
 */
function phoneCarousel() {
  // phone carousel code goes here
  const phoneCarousel = $('.Carousel--phones .owl-carousel');

  const phoneCarouselOptions = {
    items: 3,
    slideby: 3,
    dots: false,
    nav: false,
    margin: 68,
    touchDrag: true,
    pullDrag: true,
    mouseDrag: true,
    autoWidth: false,
    // center: true,
    responsive: {
      0: {
        items: 1,
        dots: false,
        nav: false,
        slideby: 1,
        // stagePadding: 20,
        margin: 22,
      },
      720: {
        items: 2,
        dots: false,
        nav: false,
        slideby: 2,
        // stagePadding: 20,
        margin: 32,
      },
      960: {
        items: 3,
        dots: false,
        nav: false,
        slideby: 3,
        margin: 42,
      },
    },
  };
  return phoneCarousel.owlCarousel(phoneCarouselOptions);
}

if (document.getElementById('js-carousel-phones')) {
  const owl_phones = phoneCarousel();
  console.log('attachOwlCarouselEvents');
  attachOwlCarouselEvents(owl_phones);
  // attach the ga tracker functionality
  const events = 'touchstart, click';
  // define the selectors as something akin to constants to avoid typos being an issue
  const navOwlSelectors = '.owl-dots, .owl-nav';
  const phoneElementSelectors = '.btn, .product--link';
  // give a name to the carousel
  const name = 'Product Carousel';
  // make the name accessible inside of the handler
  const boundGaTrackerHandler = gaTrackerHandler.bind(this, name);
  // register the event handler
  $(owl_phones).trigger('refresh.owl.carousel');

  // cheat and use js to add the class after => phone box shadow
  // const phones = $(owl_phones).find('.card--phone');
  // phones.each(function(index, phone) {
  // 	$(phone).addClass('card-box-shadow-accent');
  // });

  // $(owl_phones).on('initialized.owl.carousel', function(event) {
  // 	$(owl_phones).trigger('refresh.owl.carousel');
  // })
  $(owl_phones).on(events, navOwlSelectors, boundGaTrackerHandler);
  $(owl_phones).on(events, phoneElementSelectors, boundGaTrackerHandler);
}

if (document.getElementById('js-carousel-intro')) {
  (function () {
    var owl_intro = $('#js-carousel-intro').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      navText: ['<', '>'],
      touchDrag: true,
      pullDrag: true,
      mouseDrag: true,
      responsive: {
        0: {
          items: 1,
          dots: true,
          nav: false,
        },
        960: {
          items: 1,
          dots: true,
          nav: true,
        },
      },
    });

    var cached_index = 1,
      event_type = '';

    owl_intro.on('click', function (e) {
      if (e.target.nodeName === 'SPAN') {
        event_type = 'Dot';
      } else {
        event_type = 'Arrow';
      }
    });

    owl_intro.on('translated.owl.carousel', function (e) {
      var index = e.item.index - 1,
        tracker;

      if (index === 0) {
        index = e.item.count;
      }

      // console.log('index: ', index);

      tracker =
        'carousel|Why Mint Carousel|' +
        event_type +
        '|' +
        cached_index +
        '|' +
        index;

      // console.log(tracker);

      gaTracker.track(tracker);

      cached_index = index;
    });
  })();
}


function gaTrackerHandler(name, event) {
  const element = event.target.nodeName;
  // should probably just be using [data-ga]
  const messages = {
    BUTTON: event.target.innerText,
    IMG: event.target.alt,
    SPAN: 'DOT',
  };
  const messageData = messages[element];
  const message = `${name}|${event.type}|${messageData}`;

  gaTracker.track(message);
}

// potentially cruft
function attachOwlCarouselEvents(owlCarousel) {
  // // attach the click handlers for the buttons
  // I couldn't quite get it right for the Owl Carousel library's existing
  // nav bar
  $('.Carousel--Container').on('click', 'button', function (event) {
    // there's undoubtedly a better way to handle this
    if ($(event.target).hasClass('carousel-next')) {
      $(owlCarousel).trigger('next.owl.carousel');
    }
    if ($(event.target).hasClass('carousel-prev')) {
      $(owlCarousel).trigger('prev.owl.carousel');
    }
  });
}

if (document.getElementById('js-carousel-testimonials')) {
  var owl_testimonials = $('#js-carousel-testimonials').owlCarousel({
    items: 3,
    slideBy: 3,
    loop: false,
    margin: 30,
    nav: true,
    navText: ['<', '>'],
    touchDrag: true,
    pullDrag: true,
    mouseDrag: true,
    dotsEach: true,
    responsive: {
      0: {
        items: 1,
        dots: true,
        nav: false,
        slideBy: 1,
      },
      720: {
        items: 2,
        dots: true,
        nav: false,
        slideBy: 2,
      },
      960: {
        items: 3,
        dots: true,
        nav: true,
      },
    },
  });
  owl_testimonials.on('touchstart, click', '.owl-dots, .owl-nav', function (e) {
    var event_type = 'Arrow';

    if (e.target.nodeName === 'SPAN') {
      event_type = 'Dot';
    }

    gaTracker.track('Endorsement Carousel|selection|' + event_type);
  });

  owl_testimonials.on('changed.owl.carousel', function (e) {
    // Reset expanded card
    owl_testimonials
      .find('.js-ellipsis')
      .removeClass('Ellipsis')
      .addClass('Ellipsis');
  });

  $('.js-read-more').on('click', function (e) {
    e.preventDefault();

    $(this).closest('.card').find('.js-ellipsis').toggleClass('Ellipsis');
  });
}

if (document.getElementById('js-review-savings')) {
  var owl_review = $('#js-review-savings').owlCarousel({
    items: 2,
    slideBy: 2,
    loop: false,
    margin: 30,
    nav: true,
    navText: ['<', '>'],
    touchDrag: true,
    pullDrag: true,
    mouseDrag: true,
    dotsEach: true,
    responsive: {
      0: {
        items: 1,
        dots: true,
        nav: false,
        slideBy: 1,
      },
      720: {
        items: 2,
        dots: true,
        nav: false,
        slideBy: 2,
      },
      960: {
        items: 2,
        dots: true,
        nav: true,
      },
    },
  });

  owl_review.on('touchstart, click', '.owl-dots, .owl-nav', function (e) {
    var event_type = 'Arrow';

    if (e.target.nodeName === 'SPAN') {
      event_type = 'Dot';
    }

    gaTracker.track('Endorsement Carousel|selection|' + event_type);
  });
}

if (document.getElementById('js-hero-carousel')) {
  // Place youtube iframe api in header
  let tag = document.createElement('script');

  tag.src = 'https://www.youtube.com/iframe_api';

  let firstScriptTag = document.getElementsByTagName('script')[0];

  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  let $videos = $('#js-hero-carousel iframe');
  let $heroCarousel = $('#js-hero-carousel');

  // https://developers.google.com/youtube/iframe_api_reference#Example_Video_Player_Constructors
  window.onPlayerStateChange = function (event) {
    if (event.data == YT.PlayerState.PLAYING) {
      $heroCarousel.carousel('pause');
      // console.log('>>>>> onPlayerStateChange: PLAYING');
    } else if (event.data == YT.PlayerState.PAUSED) {
      $heroCarousel.carousel('cycle');
      // console.log('>>>>> onPlayerStateChange: PAUSED');
    }
  };

  window.onYouTubeIframeAPIReady = function () {
    $videos.each(function () {
      let player;
      let videoId = $(this).attr('id');

      player = new YT.Player(videoId, {
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    });
  };

  // https://v4-alpha.getbootstrap.com/components/carousel/#events
  $heroCarousel.on('slide.bs.carousel', () => {
    // Simply pause all videos when the carousel has completed its slide transition.
    $videos.each(function () {
      $(this)[0].contentWindow.postMessage(
        '{ "event" : "command", "func" : "pauseVideo", "args" : ""}',
        '*',
      );
    });
  });
}

if (document.getElementById('js-jumper')) {
  // 'touchstart' event binding makes :active state avaiable in mobile device
  document
    .getElementById("js-jumper")
    .addEventListener("touchstart", function () {
      console.log()
    }, true);
}

window.addEventListener('scroll', function (event) {
  pubsub.publish('window.scroll');
});

function adjustChatButtonPosition() {
  var btn = document.getElementById('js-ada-chat-button');

  if (!btn) {
    return;
  }

  if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
    if (window.matchMedia('(min-width: 768px)').matches) {
      btn.style.bottom = '75px';
    }
  } else {
    btn.style.bottom = '5px';
  }
}

pubsub.subscribe('window.scroll', adjustChatButtonPosition);

if (document.querySelector('.js-plan-selection')) {
  $('.js-plan-selection').on('click', function (event) {
    var $this = $(this),
      selection = $this.data('selection');

    $('.js-plan-selection').removeClass('active');
    $('.js-plan-info').removeClass('show');

    $this.addClass('active');
    $('.' + selection).addClass('show');
  });
}

if (document.querySelector('.js-add-plan')) {
  $('.js-add-plan').on('click', function (event) {
    event.preventDefault();

    var $this = $(this);

    pubsub.publish('cart.add_item', {
      type: 'plan',
      quantity: 1,
      price: $this.data('product-price'),
      id: $this.data('product-id'),
      tracker: $this.data('ga'),
    });
  });
}

function recalculateCheckoutTotal() {
  var prices = [],
    $shipping = document.querySelector(
      '.Order-collaterals .shipping input:checked + label .amount',
    )
      ? $('.Order-collaterals .shipping input:checked + label .amount')
      : $('.shop_table .shipping input:checked + label .amount');

  prices.push($subtotal.clone().children().remove().end().text());
  prices.push($shipping.clone().children().remove().end().text());

  /* - Remove Fees from adding to Prices for hidding taxes and fees on cart -ECOMM-2737
  $fees.each(function(i) {
    prices.push(
      $(this)
        .clone()
        .children()
        .remove()
        .end()
        .text()
    );
  });
  */

  $total.html('$' + calculatePurchaseTotal(prices));
}

function calculatePurchaseTotal(priceArray) {
  var finalTotal = priceArray.reduce(function (a, b) {
    b = parseFloat(b.replace(/,/g, '')); // values coming in as strings, remove comma, parse float

    if (!isNaN(b)) {
      return a * 1 + b * 1;
    } else {
      return a * 1;
    }
  }, 0);

  return finalTotal.toFixed(2);
}

// This shipping calculation is WAY too dependent on the markup and needs to be refactored.
if (document.querySelector('.shipping')) {
  var $subtotal = document.querySelector(
      '.Order-collaterals .Order-subtotal .amount',
    )
      ? $('.Order-collaterals .Order-subtotal .amount')
      : $('.shop_table .cart-subtotal .amount'),
    $fees = document.querySelector('.Order-collaterals .Order-fee .amount')
      ? $('.Order-collaterals .Order-fee .amount')
      : $('.shop_table .fee .amount'),
    $total = document.querySelector('.Order-collaterals .Order-total .amount')
      ? $('.Order-collaterals .Order-total .amount')
      : $('.shop_table tr.order-total .amount'),
    $shipping;



  $('.shipping #shipping_method input[type=radio]').on(
    'click',
    recalculateCheckoutTotal,
  );

  recalculateCheckoutTotal();
}

if (document.querySelector('.js-validation-entry-form')) {
  // Handling GA tracking for validation entry form
  $('.js-validation-entry-form').on('submit', function (e) {
    var data = $(this).serializeArray(),
      tracker = {};

    data.forEach(function (item, index) {
      tracker[item.name] = item.value;
    });

    if (typeof window.ga !== 'undefined') {
      window.dataLayer.push(tracker);
    }
  });
}

if (document.querySelector('.js-benefits-items')) {
  // Reveal benefit description on click
  $('.js-benefits-items').on('click', 'a', function (e) {
    e.preventDefault();

    var $container = $(this).closest('div');

    $container.toggleClass('reveal');

    $container.mouseleave(function () {
      // Reset its status on mouseleave
      $container.removeClass('reveal');
    });
  });
}

// Lord forgive me
function readyStateChanged() {
  if (document.readyState === 'complete') {
    console.log('readyState complete');
    if (!$('.privy-popup-content').length) {
      surveyModal();
    }
  }
}

if (Cookie.get('hasSurvey') > 0 && Cookie.get('hasTakenSurvey') !== '1') {
  $(document).on('readystatechange', readyStateChanged);
}

function toggleMenuOnTapOutside(e) {
  // if the parent is not the navigation
  if (0 === $(e.target).parents('.o-primaryNav').length) {
    document.querySelector('.a-hamburger').click();
    this.removeEventListener('click', toggleMenuOnTapOutside);
  }
}

// function navToggle() {
//   this.classList.toggle('o-primaryNav__navButton--active');
//   this.classList.toggle('change');
//   document.body.classList.toggle('fixed-blur');
//   document.getElementById('blur').classList.toggle('blur');
//   if (this.classList.contains('o-primaryNav__navButton--active')) {
//     document.getElementById('js-sideNav').style.width = '300px';

//     // enable event listener on blur for click to close menu
//     const body = document.querySelector('body');

//     body.addEventListener('click', toggleMenuOnTapOutside);
//   } else {
//     document.getElementById('js-sideNav').style.width = '0';
//     document
//       .querySelector('body')
//       .removeEventListener('click', toggleMenuOnTapOutside);
//   }
// }

// function displayWindowSize() {
//   var h1 =
//     window.innerHeight ||
//     document.documentElement.clientHeight ||
//     document.body.clientHeight;

//   if (h == h1) {
//     document.getElementById('js-header').style.top = '0';
//     document.getElementById('js-header').style.borderBottom = 'none';
//     document.body.classList.remove('fixed-blur');
//     document.getElementById('blur').classList.remove('blur');

//     document
//       .getElementsByClassName('dropdown')[0]
//       .classList.remove('v3-dropdown-menu--active');
//     document
//       .getElementsByClassName('dropdown')[1]
//       .classList.remove('v3-dropdown-menu--active');

//     if (window.matchMedia('(min-width: 1040px)').matches) {
//       document.getElementById('js-sideNav').style.width = 'initial';
//       document.body.style.paddingTop = '118px';
//     }
//     if (!window.matchMedia('(min-width: 1040px)').matches) {
//       document
//         .querySelector('#js-navButton')
//         .classList.remove('o-primaryNav__navButton--active');
//       document.getElementById('js-sideNav').style.width = '0';
//       document.getElementById('js-navButton').classList.remove('change');
//       document.body.style.paddingTop = '62px';
//     }
//   }

//   h = h1;
// }

// function menuToggle(e) {
//   if (!window.matchMedia('(min-width: 1040px)').matches) {
//     this.classList.toggle('v3-dropdown-menu--active');
//   }
// }

// var dropdowns = document.querySelectorAll('.v3-dropdown-toggle');

// Array.from(dropdowns).forEach((dropdown) => {
//   dropdown.addEventListener('click', function (e) {
//     e.preventDefault();
//   });
// });

// function scrollCheck() {
//   if (window.scrollY < 30) {
//     if (window.matchMedia('(min-width: 1040px)').matches) {
//       document.getElementById('js-header').style.top = '0';
//       document.body.style.paddingTop = '118px';
//     } else {
//       document.body.style.paddingTop = '62px';
//     }
//     document.getElementById('js-header').style.borderBottom = 'none';
//   } else {
//     if (window.matchMedia('(min-width: 1040px)').matches) {
//       document.getElementById('js-header').style.top = '-35px';
//       document.body.style.paddingTop = '88px';
//     } else {
//       document.body.style.paddingTop = '62px';
//     }
//     document.getElementById('js-header').style.borderBottom =
//       '1px solid #C8E4D4';
//   }
// }

// function blurToggle() {
//   if (this.classList.contains('blur')) {
//     document.body.classList.remove('fixed-blur');
//     document.getElementById('blur').classList.remove('blur');
//     document.getElementById('js-navButton').classList.remove('change');
//     document.getElementById('js-sideNav').style.width = '0';
//     document
//       .querySelector('#js-navButton')
//       .classList.remove('o-primaryNav__navButton--active');
//     document
//       .getElementsByClassName('dropdown')[0]
//       .classList.remove('v3-dropdown-menu--active');
//     document
//       .getElementsByClassName('dropdown')[1]
//       .classList.remove('v3-dropdown-menu--active');
//   }
// }

// var h =
//   window.innerHeight ||
//   document.documentElement.clientHeight ||
//   document.body.clientHeight;

// window.addEventListener('resize', displayWindowSize);
// window.addEventListener('scroll', scrollCheck);
// document.querySelector('#blur').addEventListener('click', blurToggle);

// if(window.page !== "checkout") {
//   document.querySelector('#js-navButton').addEventListener('click', navToggle);
// }

// document
//   .getElementsByClassName('dropdown')[0]
//   .addEventListener('click', menuToggle);
// document
//   .getElementsByClassName('dropdown')[1]
//   .addEventListener('click', menuToggle);

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

var qty = getCookie('woocommerce_cart_quantity');
var cartItemsElement = document.querySelector('#o-primaryNav__cartItems');

if (qty > 0 && cartItemsElement) {
  cartItemsElement.innerText = qty;
  cartItemsElement.classList.add('o-primaryNav__cartItems');
}

// detects if the message with class wc-forward shows, which is what happens when you add to cart using v3
// the css has the woocommerce hidden by default, so set to display block to prevent flashing
// added detection if error message contains Coupon Code already Applied, do not show error message
var woocommerce_notice = document.querySelector('.woocommerce-notices-wrapper');
if (
  woocommerce_notice &&
  !(
    getCookie('ultra_custom_discount') &&
    woocommerce_notice.textContent.indexOf('Coupon code already applied') > -1
  )
) {
  var cart_msg = woocommerce_notice.querySelector('.wc-forward');

  if (cart_msg) {
    woocommerce_notice.innerHTML = '';
  }

  woocommerce_notice.style.display = 'block';
}
